import React from 'react';

import type { IFormSelect } from './types';
import type { IBasicClientFolder, IBasicFolder } from '..';

import { Select } from '..';

interface IFolderSelectProps extends IFormSelect {
  folders: IBasicClientFolder[];
}

const createOptionsFromBasicFolders = (folders: IBasicFolder[], indent: number): React.ReactNode => {
  return folders.map(folder => (
    <React.Fragment key={`folder-${folder.id}`}>
      <option value={JSON.stringify({ id: folder.id, clientId: folder.clientId })}>
        {`${'-'.repeat(indent)} ${folder.name}`}
      </option>
      {createOptionsFromBasicFolders(folder.children, indent + 1)}
    </React.Fragment>
  ));
};

const createOptionsFromClientFolder = (folders: IBasicClientFolder[]): React.ReactNode => {
  const indent = 1;
  return folders.map(clientFolder => (
    <React.Fragment key={`client-${clientFolder.clientId}`}>
      <option disabled>{clientFolder.clientName}</option>
      {createOptionsFromBasicFolders(clientFolder.children, indent)}
    </React.Fragment>
  ));
};

const FolderSelect = ({ folders, ...rest }: IFolderSelectProps): React.ReactElement => (
  <Select {...rest}>{createOptionsFromClientFolder(folders)}</Select>
);

export { FolderSelect };
